import { ProfileService } from '@/services/api'
import appConfig from '@/config.js'
import store from '@/store'
import utils from '@/mixins/utils.mixin'

export default {
  state: {
    profile: {},
    roles: []
  },
  getters: {
    profile: state => {
      return state.profile
    },
    roles: state => {
      return state.roles
    },
    isSuperAdmin: state => {
      return state.roles.includes(window.roles.SUPER_ADMIN)
    },
    isOperatorSupervisor: (state, getters) => {
      return getters.isSuperAdmin || state.roles.includes(window.roles.OPERATOR_SUPERVISOR)
    },
    isGcmAdmin: (state, getters) => {
      return state.roles.includes(window.roles.GCMR_ADMIN)
    },
    isCompanyAdmin: (state, getters) => {
      return getters.isSuperAdmin || state.roles.includes(window.roles.COMPANY_ADMIN)
    },
    // Matched appConfig.restrictedAccess entry, or null when the profile is not
    // confined. Privileged roles short circuit first: isCompanyAdmin above cannot be
    // reused here because it ORs in isSuperAdmin, which would confine super admins.
    restrictedAccessConfig: (state, getters) => {
      if (getters.isSuperAdmin || getters.isGcmAdmin) {
        return null
      }
      return appConfig.restrictedAccess?.find(x => state.roles.includes(x.role)) || null
    },
    isRestrictedAccess: (state, getters) => {
      return !!getters.restrictedAccessConfig
    },
    addresses: state => {
      return []
    }
  },
  mutations: {
    setProfile(state, payload) {
      state.profile = payload
    },
    setRoles(state, payload) {
      state.roles = payload.map(x => x.name)
    }
  },
  actions: {
    async fetchProfile({ commit }) {
      await store.dispatch('setEcosystemModules', store.getters.eid)
      await store.dispatch('setEcosystemCountries')

      const payload = {
        params: {
          includes: [
            'platform_user_authorizations.platform.application',
            'company.applications.platform',
            'company.users',
            'company.stores.place',
            'company.marketing_settings.setting',
            'company.notification_configs'
          ]
        }
      }
      return ProfileService.get(payload)
        .then(response => {
          commit('setProfile', response.data)
          commit('setRoles', response.data.roles)
          if (response.data.company) {
            if (response.data.company.country_iso_code !== window.country) {
              document.cookie = 'country=' + response.data.company.country_iso_code + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
              window.country = response.data.company.country_iso_code
              document.cookie = 'phonePrefix=' + window.countries.find(x => x.iso_code === response.data.company.country_iso_code).front_config.i18n.phonePrefix + ';path=/; SameSite=' + process.env.COOKIE_SAME_SITE + '; ' + process.env.COOKIE_SECURE
              window.phonePrefix = window.countries.find(x => x.iso_code === response.data.company.country_iso_code).front_config.i18n.phonePrefix
            }
            const frontConfig = window.countries.find(x => x.iso_code === response.data.company.country_iso_code).front_config
            commit('setFrontConfig', frontConfig)
            if (frontConfig.ecosystem) {
              commit('setEcosystem', frontConfig.ecosystem)
            }
          }
          // commit('setAppRoles', {
          //   params: {
          //     sort: [{
          //       key: 'name',
          //       direction: 'asc'
          //     }]
          //   }
          // })

          if (response.data.meta?.persistentStorage) {
            for (const [key, value] of Object.entries(response.data.meta.persistentStorage)) {
              utils.methods.setLocalStorage(key, value, false)
            }
          }
        })
    },
    updateUser({ dispatch }, data) {
      return ProfileService.update(data)
        .then(response => {
          dispatch('fetchProfile')
        })
    },
    changePassword({ dispatch }, data) {
      return ProfileService.changePassword(data)
        .then(response => {
          dispatch('fetchProfile')
        })
    },
    emailPassword({ dispatch }, data) {
      return ProfileService.emailPassword(data)
    },
    resetPassword({ dispatch }, data) {
      return ProfileService.resetPassword(data)
    },
    checkAccessRules({ dispatch }) {
      let hasAccess = false
      for (const rule of appConfig.accessRules) {
        if (!hasAccess && store.getters[rule]) {
          hasAccess = true
        }
      }
      return hasAccess
    }
  }
}
